import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { PageMeta } from '@/lib/api';
import { pageCount, rangeLabel } from './pagination-utils';
import { Button } from './Button';
import styles from './Pagination.module.css';

/** Offset pagination matching the API's `meta: { page, pageSize, total }`. */
export function Pagination({
  meta,
  onPageChange,
}: {
  meta: PageMeta;
  onPageChange: (page: number) => void;
}) {
  const pages = pageCount(meta);
  return (
    <nav className={styles.pagination} aria-label="Pagination">
      <span className={styles.range}>{rangeLabel(meta)}</span>
      <div className={styles.buttons}>
        <Button
          size="sm"
          icon={<ChevronLeft size={14} />}
          disabled={meta.page <= 1}
          onClick={() => onPageChange(meta.page - 1)}
          aria-label="Previous page"
        />
        <span className={styles.page} aria-current="page">
          Page {meta.page} of {pages}
        </span>
        <Button
          size="sm"
          icon={<ChevronRight size={14} />}
          disabled={meta.page >= pages}
          onClick={() => onPageChange(meta.page + 1)}
          aria-label="Next page"
        />
      </div>
    </nav>
  );
}
